/**
 * 文件说明:
 *
 * auth layout
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {useHzDocTitle, useCheckPermission} from 'hooks'
import HzPageMain from './components/page-main'
import HzPageHeader from './components/page-header'
import {useGlobalLayoutContext} from './components/header/context'
import {useProjectLayoutWrapContext} from './components/project-layout-wrap/context'

function AuthLayout(props) {
    const {PageComponent, pageProps} = props

    const {
        pageHeaderType,
        pageMainClassName,
        PageMain = HzPageMain,
        PageHeader = HzPageHeader,
        noCheckPermission = false,
        pageMainAntConfig,
        pageHeaderOption,
        usePageMain = true,
        useTitle: useUserTitle = useHzDocTitle,
    } = PageComponent?.hzLayoutOption ?? {}

    useCheckPermission({pathname: pageProps?.location?.pathname, noCheckPermission})

    const {setHzHeaderHelp, restoreHzHeaderHelp} = useGlobalLayoutContext()
    const {useTitle: useProjectTitle} = useProjectLayoutWrapContext()

    const useTitle = useUserTitle ?? useProjectTitle

    return usePageMain ? (
        <PageMain
            setHzHeaderHelp={setHzHeaderHelp}
            restoreHzHeaderHelp={restoreHzHeaderHelp}
            antConfig={pageMainAntConfig}
            className={pageMainClassName}
            PageHeader={
                <PageHeader
                    setHzHeaderHelp={setHzHeaderHelp}
                    useTitle={useTitle}
                    restoreHzHeaderHelp={restoreHzHeaderHelp}
                    pageProps={pageProps}
                    pageHeaderOption={pageHeaderOption}
                    pageHeaderType={pageHeaderType}
                    PageComponent={PageComponent}
                />
            }
        />
    ) : (
        <PageComponent
            pageHeaderType={pageHeaderType}
            pageHeaderOption={pageHeaderOption}
            pageProps={pageProps}
            useTitle={useTitle}
            setHzHeaderHelp={setHzHeaderHelp}
            restoreHzHeaderHelp={restoreHzHeaderHelp}
        />
    )
}

export default AuthLayout
